import { render, staticRenderFns } from "./ElSubMenu.vue?vue&type=template&id=d6e0a5a4&"
import script from "./ElSubMenu.vue?vue&type=script&lang=ts&"
export * from "./ElSubMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports